export class InternalEquipmentBalanceMass {
    id: number;
    idEquipment: number;
    mass: string;
    idMass: string;
    valuePhysical: number;
    uncertaintyTypical: number;
    idUnit: number;
    unit: string;
}

export interface MassRowDisplay {
    mass: string;
    idMass: string | null;
    g?: number;
    uncertaintyG?: number;
    idG?: number;
    unitG?: string;
    kg?: number;
    uncertaintyKg?: number;
    idKg?: number;
    unitKg?: string;
    mg?: number;
    uncertaintyMg?: number;
    idMg?: number;
    unitMg?: string;
}